import { safeGet, safeSet } from "./safeStorage";

export type ClientRateLimit = {
  /** True if `key` hasn't been marked within the window (or never). */
  canRequest: (key: string) => boolean;
  /** Stamp `key` with the current time. Call only after a successful action. */
  mark: (key: string) => void;
};

/**
 * A localStorage-backed per-key rate-limit guard. This is a UX softener, not a
 * real defense — the backend Redis limiter is the enforcement layer. Each
 * feature owns its own `storageKey` namespace and `windowMs`.
 */
export function createClientRateLimit(storageKey: string, windowMs: number): ClientRateLimit {
  function readMap(): Record<string, number> {
    const raw = safeGet(storageKey);
    if (!raw) return {};
    try {
      return JSON.parse(raw) as Record<string, number>;
    } catch (err) {
      console.warn(`[clientRateLimit] corrupt entry for ${storageKey}, resetting`, err);
      return {};
    }
  }

  return {
    canRequest(key) {
      const last = readMap()[key];
      return !last || Date.now() - last > windowMs;
    },
    mark(key) {
      const map = readMap();
      map[key] = Date.now();
      safeSet(storageKey, JSON.stringify(map));
    },
  };
}
